import React from 'react';
import { SearchInput } from '../ui';
import { ProcessorEntry } from './types';

const dotFor = (actualState?: string) =>
  actualState === 'crashed' ? 'pc-dot--error'
  : ['starting', 'running', 'finishing'].includes(actualState ?? '') ? 'pc-dot--running'
  : 'pc-dot--idle';

export const ProcessorList: React.FC<{
  entries: ProcessorEntry[];
  states: Record<string, { actualState?: string } | undefined>;
  selectedId: string;
  onSelect: (id: string) => void;
  query: string;
  onQueryChange: (q: string) => void;
}> = ({ entries, states, selectedId, onSelect, query, onQueryChange }) => {
  const visible = entries.filter((e) =>
    `${e.name} ${e.description}`.toLowerCase().includes(query.toLowerCase()));
  return (
    <div className="pc-list">
      <SearchInput value={query} onChange={onQueryChange} placeholder="Search processors…" />
      <ul>
        {visible.length === 0 && <li className="pc-list__empty">No processors match</li>}
        {visible.map((e) => (
          <li key={e.id}>
            <button
              type="button"
              className={`pc-list__item${e.id === selectedId ? ' pc-list__item--active' : ''}`}
              onClick={() => onSelect(e.id)}
            >
              <span className={`pc-dot ${dotFor(states[e.id]?.actualState)}`} />
              {e.name}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
